module.exports = "/_next/static/images/tnm-sticker-dark-grey-mint-d17609903432977863c9b1164f0a7373.svg";